// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grey-bg[data-v-1ace5140] {\n  background-color: #ededed;\n}\n", ""]);
// Exports
module.exports = exports;
